import { render, staticRenderFns } from "./ItemClassGroup.vue?vue&type=template&id=0d76ce49"
import script from "./ItemClassGroup.vue?vue&type=script&lang=js"
export * from "./ItemClassGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports